import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaRadialProgress extends HTMLAhaRadialProgressElement {}

/**
 * Custom radial progress component.
 * @slot title - Contents of the title.
 * @slot subtitle - Contents of the subtitle.
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-radial-progress',
  styleUrl: 'aha-radial-progress.css',
  shadow: true,
})
export class AhaRadialProgress {
  @Element() host!: HTMLAhaRadialProgressElement;
  /**
   * Size of the radial progress
   */
  @Prop({ reflect: true }) size: 'medium' | 'small' = 'medium';

  /**
   * @deprecated
   * For backwards compatibility only
   */
  @Prop({ attribute: 'subtitle' }) legacySubtitle?: string;

  render() {
    return (
      <Host>
        <slot></slot>
        <div id="label">
          <div id="title">
            <slot name="title"></slot>
          </div>
          <div id="subtitle">
            <slot name="subtitle">{this.legacySubtitle}</slot>
          </div>
        </div>
      </Host>
    );
  }
}
